module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/topVisa.bfc39a44.png";